import _ from 'lodash'

import { House, State } from '../../types'

const HIDDEN_HOUSE_IDS = [0]

export function getHouses(state: State): House[] {
	return _.values(state.HouseById).filter(
		(house) => !HIDDEN_HOUSE_IDS.includes(house.id),
	)
}

export function getHouse(state: State, houseId: number): House {
	return state.HouseById[houseId]
}
